// Base 1 diagnostic questions (12 questions across 5 spheres)
const base1 = [
    // ── Bendra (General) — 3 questions ──
    {
      id: 'q1',
      sphere: 'bendra',
      question: 'Kai reikia priimti svarbų sprendimą gyvenime arba veikloje:',
      choices: {
        a: 'Sprendimus priimu lengvai ir vadovaujuosi savo nuomone bei intuicija.',
        b: 'Man saugiau, kai galutinį žodį taria autoritetai ar aplinkybės – taip jaučiu mažiau atsakomybės.',
        c: 'Priklauso nuo situacijos svorio: kartais nusprendžiu akimirksniu, kartais reikia laiko pasitarti.',
      },
    },
    {
      id: 'q2',
      sphere: 'bendra',
      question: 'Asmeninės ribos ir santykis su išoriniu pasauliu:',
      choices: {
        a: 'Tvirtai ir garsiai moku pasakyti „ne" ir nubrėžti ribas, jei kas nors bando primesti savo taisykles.',
        b: 'Dažniau linkstu nusileisti, prisitaikyti ir nutylėti, kad tik išvengčiau konfrontacijos.',
        c: 'Ribas brėžiu tik tada, kai situacija tampa kritinė, kitu atveju ieškau lankstaus kompromiso.',
      },
    },
    {
      id: 'q3',
      sphere: 'bendra',
      question: 'Elgesys, kai idėjos ar planai nesulaukia aplinkinių palaikymo:',
      choices: {
        a: 'Tai mane tik dar labiau užveda – esu pasiruošęs veikti ir vienas, nes tikiu savimi.',
        b: 'Greitai prarandu pradinį entuziazmą, pradedu abejoti savo jėgomis ir dažniausiai atsisakau sumanymo.',
        c: 'Sustoju analizuoti: jei aplinka priešinasi, ieškau logiškų priežasčių ir galiu laikinai atidėti planą.',
      },
    },
    // ── Karjera (Career) — 2 questions ──
    {
      id: 'q4',
      sphere: 'karjera',
      question: 'Iniciatyva ir naujų projektų ar veiklų pradžia:',
      choices: {
        a: 'Degantis entuziazmas: jei sugalvojau naują kryptį, iškart imuosi veiksmų ir nereikia kitų leidimo.',
        b: 'Ilgas delsimas: ieškau saugumo, idealaus momento arba laukiu, kol kas nors kitas duos impulsą.',
        c: 'Pradedu tik tada, kai turiu aiškų, racionalų planą arba kai aplinkybės natūraliai atveria tam duris.',
      },
    },
    {
      id: 'q5',
      sphere: 'karjera',
      question: 'Pozicija komandoje, darbe ar profesinėje aplinkoje:',
      choices: {
        a: 'Natūraliai prisiimu lyderio rolę, organizuoju procesus ir rodau kryptį.',
        b: 'Mieliau renkuosi vykdytojo rolę, lieku šešėlyje, o strateginį vairą perleidžiu kitiems.',
        c: 'Galiu vesti žmones į priekį, bet lygiai taip pat lengvai dirbu komandoje, jei kryptis prasminga.',
      },
    },
    // ── Santykiai (Relationships) — 3 questions ──
    {
      id: 'q6',
      sphere: 'santykiai',
      question: 'Iniciatyva ir atsakomybė asmeniniame gyvenime bei partnerystėje:',
      choices: {
        a: 'Inicijuoju idėjas, kur keliauti, ką veikti, ir prisiimu atsakomybę už bendrus sprendimus.',
        b: 'Iniciatyvą visiškai atiduodu partneriui ar draugams – patogiau prisitaikyti prie kitų plano.',
        c: 'Sprendimus priimame kartu: kartais iniciatyvą rodau aš, kartais leidžiu kurti partneriui.',
      },
    },
    {
      id: 'q7',
      sphere: 'santykiai',
      question: 'Asmeninės erdvės ir nepriklausomybės poreikis artimuose santykiuose:',
      choices: {
        a: 'Man gyvybiškai svarbu turėti laiko tik sau, savo asmeniniams reikalams ir nepriklausomai erdvei.',
        b: 'Esu visiškai ištirpęs kito žmogaus poreikiuose, mano nuotaika ir diena priklauso nuo partnerio ar šeimos.',
        c: 'Sėkmingai balansuoju: moku atsiriboti ir pabūti su savimi, bet jei artimiesiems reikia, skiriu jiems laiką.',
      },
    },
    // ── Finansai (Finance) — 2 questions ──
    {
      id: 'q8',
      sphere: 'finansai',
      question: 'Finansinių sprendimų ir pirkinių valdymas:',
      choices: {
        a: 'Sprendžiu drąsiai, kur nukreipti pinigus, pasitikiu savo finansine uosle ir nebijau rizikos.',
        b: 'Finansuose ieškau tik stabilios garantijos, baiminuosi praradimų, todėl dėl išlaidų būtina pasitarti.',
        c: 'Svarbius finansinius pirkinius planuoju nuosekliai, bet spontaniškiems norams sprendimą priimu savarankiškai.',
      },
    },
    {
      id: 'q9',
      sphere: 'finansai',
      question: 'Vidinė nuostata dėl savo pajamų srauto ir materialių pasiekimų:',
      choices: {
        a: 'Jaučiu, kad mano finansai priklauso tik nuo mano pastangų, drąsos ir asmeninio įdirbio.',
        b: 'Jaučiuosi finansiškai priklausomas nuo išorinių aplinkybių, darbdavio malonės ar kitų žmonių.',
        c: 'Žinau, kad mano veiksmai kuria pinigus, bet priimu ir rinkos ar gyvenimo situacijų įtaką, kurios negaliu kontroliuoti.',
      },
    },
    // ── Savirealizacija (Self-Realization) — 3 questions ──
    {
      id: 'q10',
      sphere: 'savirealizacija',
      question: 'Reakcija į rutinos ir sąstingio periodus gyvenime:',
      choices: {
        a: 'Viduje viskas verda, jaučiu sąstingį, todėl dirbtinai inicijuoju pokyčius ar naują pradžią.',
        b: 'Rutina suteikia ramybės ir stabilaus saugumo pojūtį, sąmoningai vengiu bet kokių staigių posūkių.',
        c: 'Rutiną priimu kaip būtiną poilsio ar jėgų kaupimo etapą, tačiau stebiu, kad ji neužsitęstų per ilgai.',
      },
    },
    {
      id: 'q11',
      sphere: 'savirealizacija',
      question: 'Santykis su savo talentais ir unikaliu potencialu:',
      choices: {
        a: 'Girdžiu savo pašaukimą, drąsiai realizuoju talentus ir kuriu tai, kas svarbu, nelaukdamas pritarimo.',
        b: 'Kūrybinę savirealizaciją atidedu ateičiai, nes dabar visą energiją skiriu praktiškiems reikalams ir stabilumui.',
        c: 'Realizuoju save tiek, kiek leidžia esamos gyvenimo sąlygos, po truputį judėdamas link savo svajonių.',
      },
    },
    {
      id: 'q12',
      sphere: 'savirealizacija',
      question: 'Gyvenimo sunkumų ir asmeninių pamokų priėmimas:',
      choices: {
        a: 'Krizes ir sunkumus priimu kaip progą augti – prisiimu atsakomybę už savo pamokas ir transformaciją.',
        b: 'Sunkumuose linkstu užsidaryti, gailėtis savęs arba kaltinti aplinkybes, jaučiuosi įstrigęs aklavietėje.',
        c: 'Sunkumus išgyvenu emociškai, bet nurimus jausmams ieškau logiškos išeities ir judu toliau.',
      },
    },
  ];

export default base1;
